import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-969eed7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "available-checklist-body" }
const _hoisted_2 = { class: "series-list" }
const _hoisted_3 = { class: "id" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pretitle" }, "TAP TO ACTIVATE OR DEACTIVATE A CHECKLIST", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "checklist-list" }

import { ref, shallowRef } from 'vue';
import { Series } from '../../../../ecs/series/main';
import { SelectableChecklist } from '../../../../ecs/types';
import DoubleSquareCheckBox from '../../../DoubleSquareCheckBox.vue';
import SelectableChecklistItem from './SelectableChecklistItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableChecklistBodyWidget',
  props: {
    checklists: null
  },
  setup(__props: any) {

const props = __props as { checklists: SelectableChecklist[] }

function hasSeries(checklist: SelectableChecklist) {
  return checklist.composable.checklist.value.series.id !== Series.UNIDENTIFIED;
}



const selectedChecklistSeries = ref<string | null>(null);

const displayedChecklists = shallowRef<SelectableChecklist[]>([]);

const checklistSeries: Series[] = props.checklists
  .filter(hasSeries)
  .reduce((acc, checklist) => {
    const series = checklist.composable.checklist.value.series;
    const found = acc.find((item) => item.id === series.id);
    if (!found) {
      acc.push(series);
    }
    return acc;
  }, [] as Series[]);

const handleSeriesItemClick = (checklistBySeriesMapItem: string) => {
  const series = checklistBySeriesMapItem;
  if (selectedChecklistSeries.value === series) {
    selectedChecklistSeries.value = null;
    displayedChecklists.value = [];
  } else {
    selectedChecklistSeries.value = series;
    displayedChecklists.value = props.checklists.filter(
      (checklist) => checklist.composable.checklist.value.series.id === series
    );
  }
};

function onSelect(checklist: SelectableChecklist) {
  if (hasCompletableItems(checklist)) {
    checklist.selected.value = !checklist.selected.value;
    checklist.setSelected(true);
  }
}

const hasCompletableItems = (checklist: SelectableChecklist) => {
  return checklist.composable.enabled;
};

const seriesHasSelectedChecklists = (series: string) => {
  return props.checklists.some(
    (checklist) =>
      checklist.composable.checklist.value.series.id === series &&
      checklist.selected.value
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checklistSeries), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", { selected: selectedChecklistSeries.value === item.id }])
        }, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(item.id), 1),
          _createVNode(DoubleSquareCheckBox, {
            selected: selectedChecklistSeries.value === item.id,
            "has-active": seriesHasSelectedChecklists(item.id),
            onClick: ($event: any) => (handleSeriesItemClick(item.id)),
            class: "checkbox"
          }, null, 8, ["selected", "has-active", "onClick"]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1)
        ], 2))
      }), 128))
    ]),
    _hoisted_5,
    (selectedChecklistSeries.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedChecklists), (checklist, index) => {
        return (_openBlock(), _createBlock(SelectableChecklistItem, {
          class: _normalizeClass(["checklist", {
          disabled: !hasCompletableItems(checklist)
        }]),
          key: index,
          completable: checklist,
          onClick: ($event: any) => (onSelect(checklist))
        }, null, 8, ["class", "completable", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})